import { gql } from '../../../apollo/__generated__';

export const STAFF_LEAVE_EVENT = gql(`
  mutation StaffLeaveEvent($staffLeaveEventInput: StaffLeaveEventInput!) {
    staffLeaveEvent(staffLeaveEventInput: $staffLeaveEventInput) {
      id
      usersCount
    }
  }
`);
